import { Separator, Stack, Text } from '@chakra-ui/react';
import type { SeparatorProps, StackProps, TextProps } from '@chakra-ui/react';

type FeatureContentTemplateProps = {
	title:       React.ReactNode;
	children:    React.ReactNode;
	_stack?:     StackProps;
	_text?:      TextProps;
	_Separator?: SeparatorProps;
};

const FeatureContentTemplate = ({
	title,
	children,
	_stack,
	_text,
	_Separator,
}: FeatureContentTemplateProps) => {
	return (
		<Stack
			gap={2}
			layerStyle={'black'}
			{..._stack}
		>
			<Text as={'h2'} textStyle={'h3'} {..._text}>
				{title}
			</Text>
			<Separator
				border={'0.5px solid'}
				borderColor={'secondary'}
				mb={2}
				{..._Separator}
			/>
			{children}
		</Stack>
	);
};

export default FeatureContentTemplate;